<template lang="html">
  <div class="m-auto">
    <div class="floorplan-compare-detail container-fluid">
      <!-- Details -->
      <floorplan-info :floorplan="floorplan" />

      <!-- Floor plan image -->
      <div class="fp-image py-3" :class="{ 'loaded': loaded }">
        <img :src="floorplanImageUrl" />
      </div>

      <!-- Details button -->
      <div class="bottom-actions
      d-flex justify-content-center col-6">
        <router-link :to="{ name: 'FloorplanDetail', params: { id: floorplan.id }}"
        tag="button" class="btn btn-action">
          Details
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FloorplanInfoComponent from '@/components/Floorplan/FloorplanInfo';

export default {
  name: 'floorplan-compare-detail',
  props: {
    floorplan: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      floorplanImg: null,
      loaded: false
    };
  },
  computed: {
    ...mapState({
      assetsUrl: state => state.project.assetsUrl
    }),
    floorplanImageUrl() {
      return this.assetsUrl + this.floorplan.assets.floorplan.url;
    }
  },
  methods: {
    loadFloorplanImg() {
      this.floorplanImg = new Image();
      this.floorplanImg.onload = () => {
        setTimeout(() => {
          this.loaded = true;
        }, 250, this);
      };
      this.floorplanImg.src = this.assetsUrl + this.floorplan.assets.floorplan.url;
    }
  },
  created() {
    this.loadFloorplanImg();
  },
  watch: {
    floorplan() {
      this.loadFloorplanImg();
    }
  },
  components: {
    'floorplan-info': FloorplanInfoComponent
  }
};
</script>

<style lang="scss" scoped>
.floorplan-compare-detail {
  max-height: 100vh;
  top: -$action-bar-height;
  -webkit-overflow-scrolling: touch;
  background-color: white;

  .fp-image {
    opacity: 0;
    transition: opacity 0s ease-out;
    height: 70vh;

    &.loaded {
      min-height: initial;
      opacity: 1;
      transition: opacity 0.25s ease-out;
    }

    @media screen and (max-width: $breakpoint-xl) {
      height: 60vh;
    }

    @media screen and (max-width: $breakpoint-lg) {
      height: 50vh;
    }
  }

  .fp-image img {
    max-width: 100%;
    max-height: 70vh;
    width: 100%;
    height: 100%;
    object-fit: contain;

    @media screen and (max-width: $breakpoint-xl) {
      max-height: 60vh;
    }

    @media screen and (max-width: $breakpoint-lg) {
      max-height: 50vh;
    }
  }

  .bottom-actions {
    position: fixed;
    bottom:  20px;
    z-index: 999;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanCompare/FloorplanCompareDetail.vue